import { 
  DashboardOutlined,FolderOpenOutlined,FilePptOutlined 
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

/*
const dashBoardNavTree = [{
  key: 'home',
  path: `${APP_PREFIX_PATH}/home`,
  title: 'home',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: []
}]
*/
const dashBoardNavTree = [{
  key: 'pages',
  path: `${APP_PREFIX_PATH}/home`,
  title: 'CMS Section',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
    {
      key: 'page-home',
      path: `${APP_PREFIX_PATH}/home`,
      title: 'Home ',
      icon: FilePptOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'page-about',
      path: `${APP_PREFIX_PATH}/about`,
      title: 'About ',
      icon: FilePptOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'page-blog',
      path: `${APP_PREFIX_PATH}/blog_intro`,
      title: 'Blog',
      icon: FilePptOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'page-contact',
      path: `${APP_PREFIX_PATH}/contact`,
      title: 'Contact',
      icon: FilePptOutlined,
      breadcrumb: false,
      submenu: []
    },
    

  ]
}]


const crudNavTree = [{
  key: 'cruds',
  path: `${APP_PREFIX_PATH}/blog_crud`,
  title: 'Blog & Cars',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: [
  
    {
      key: 'blog',
      path: `${APP_PREFIX_PATH}/blog`,
      title: 'Blog  Content ',
      icon: FolderOpenOutlined,
      breadcrumb: false,
      submenu: []
    },
    {
      key: 'cars',
      path: `${APP_PREFIX_PATH}/cars`,
      title: 'Car Content ',
      icon: FolderOpenOutlined,
      breadcrumb: false,
      submenu: []
    }, 

    {
      key: 'advertise-requests',
      path: `${APP_PREFIX_PATH}/advertise-requests`,
      title: 'Advertise Requests ',
      icon: FolderOpenOutlined,
      breadcrumb: false,
      submenu: []
    },

  ]
}]

const navigationConfig = [
  ...dashBoardNavTree,
  ...crudNavTree
]

export default navigationConfig;
